<script lang="ts">
  import ConfirmModal from "$components/modals/confirmation-modal.svelte";
  import { cartGet, cartUpdateOnPriceChange } from "$lib/store/cart-context";
  import { closeAllModals, closeModal, onBeforeClose, openModal } from "@thehood/svlib";

  interface IMessage {
    sku: string;
    message: string;
  }

  export let onCloseCallback: (skus: string[]) => void = async (skus: string[]) => {
    // Pass Sku to remove
    try {
      const resp = await cartUpdateOnPriceChange(skus);
      if (!resp.ok) {
        throw new Error(`Something went wrong on price refresh!`);
      }

      await cartGet();
      closeAllModals();
    } catch (err) {
      closeModal();
      openModal(ConfirmModal, {
        title: "Error",
        message: (err as Error).message,
      });
    }
  };

  export let itemsChange: IMessage[] = [];
  const selectedMap = new Map(itemsChange.map(v => [v.sku, true]));

  function clickToSelect(ev: Event, item: IMessage) {
    ev.stopImmediatePropagation();
    const isSelect = selectedMap.has(item.sku) ? !selectedMap.get(item.sku) : true;
    selectedMap.set(item.sku, isSelect);
  }

  let allowClose = false;
  async function approveFn(ev: Event) {
    ev.stopImmediatePropagation();
    const removeSku = Array.from(selectedMap.entries())
      .filter(([sku, isSelected]) => !isSelected)
      .map(([sku]) => sku);
    allowClose = true;
    // On Select  call to remove unselected
    onCloseCallback(removeSku);
  }

  onBeforeClose(() => allowClose);
</script>

<section class="price">
  <h2 class="pf-600">Some items have changed in price. Please select the ones you wish to keep.</h2>
  <div class="items">
    {#each itemsChange as item}
      <div class="button">
        <p class="pf-400">{item.message}</p>
        <input type="checkbox" checked={selectedMap.has(item.sku)} on:change={ev => clickToSelect(ev, item)} />
      </div>
    {/each}
  </div>

  <div class="actions">
    <button on:click={approveFn}>Confirm</button>
  </div>
</section>

<style lang="scss">
  @use "@styles/breakpoint-mixins";
  section {
    z-index: var(--z2);
    padding: 30px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    h2 {
      font-size: 25px;
    }
    .items {
      padding: 20px 0;
      .button {
        display: grid;
        grid-template-columns: 1fr auto;
        width: 100%;
        margin: 5px;
        padding: 10px 20px;
        border: 1px solid #ccc;
        border-radius: 4px;
        justify-content: space-between;
        p {
          padding-right: 30px;
          text-align: left;
        }
        input {
          width: 20px;
          padding: 20px;
        }
      }

      .button:nth-child(odd) {
        background-color: #fff;
      }
      .button:nth-child(even) {
        background-color: #f8f8f8;
      }
    }
    .actions {
      width: 100%;
      display: flex;
      justify-content: end;
      gap: 10px;
      button {
        padding: 10px;
        border-radius: 4px;
      }
      button:first-child {
        background-color: lightcoral;
        color: #fff;
      }
      button:last-child {
        background-color: lightblue;
      }
    }
  }
</style>
